import { Fragment } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ResourceCategoryType } from '@mews-commander/legacy-data-structures';
import { LocalizedEnumify } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getRateGroupName } from '@mews-commander/legacy-entities/src/ducks/rateGroups';
import {
    getShortenedDayNames,
    getSidebarBaseRateName,
    getSidebarExactRateName,
    getSidebarResourceCategoryName,
} from '../../../../selectors';
import { DateRangeLabel } from '../../../common';
import { ConditionLabel } from '../labels';

const ConditionsSection = ({
    baseRateName,
    exactRateName,
    endUtc,
    rateGroupName,
    resourceCategoryName,
    resourceCategoryType,
    shortDayNames,
    startUtc,
    type,
}: $TSFixMe) => (
    <Fragment>
        <ConditionLabel
            conditionValue={<DateRangeLabel startUtc={startUtc} endUtc={endUtc} />}
            conditionTextKey={type}
        />
        <ConditionLabel conditionValue={shortDayNames} conditionTextKey={TextKey.Days} />
        {exactRateName ? <ConditionLabel conditionTextKey={TextKey.ExactRate} conditionValue={exactRateName} /> : null}
        {baseRateName ? <ConditionLabel conditionTextKey={TextKey.BaseRate} conditionValue={baseRateName} /> : null}
        {rateGroupName ? <ConditionLabel conditionTextKey={TextKey.RateGroup} conditionValue={rateGroupName} /> : null}
        {resourceCategoryName ? (
            <ConditionLabel conditionTextKey={TextKey.ResourceCategory} conditionValue={resourceCategoryName} />
        ) : null}
        {resourceCategoryType ? (
            <ConditionLabel
                conditionTextKey={TextKey.ResourceCategoryType}
                conditionValue={<LocalizedEnumify enumValue={ResourceCategoryType.getByName(resourceCategoryType)} />}
            />
        ) : null}
    </Fragment>
);

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        baseRateName: getSidebarBaseRateName,
        exactRateName: getSidebarExactRateName,
        rateGroupName: getRateGroupName,
        resourceCategoryName: getSidebarResourceCategoryName,
        shortDayNames: getShortenedDayNames,
    })
)(ConditionsSection);
